import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateImgAnatomics from '../../../state/stateImgAnatomics';
import stateFilterImgAnatomic from '../../../state/stateFilterImgAnatomic';

function QueryAnatomic() {
  const [anatomic] = useRecoilState(stateImgAnatomics);
  const [filterAnatomic, setFilterAnatomic] = useRecoilState(
    stateFilterImgAnatomic
  );
  const handleChange = useCallback(
    (
      event: React.SyntheticEvent<Element, Event>,
      value: BeaconFilterItem | null
    ) => {
      if (((value || {}).id || '') !== ((filterAnatomic || {}).id || '')) {
        setFilterAnatomic(value);
      }
    },
    [filterAnatomic, setFilterAnatomic]
  );

  if (0 < anatomic.length) {
    return (
      <Autocomplete
        fullWidth
        disablePortal
        options={anatomic}
        renderInput={(params) => <TextField {...params} margin="dense" />}
        value={filterAnatomic}
        onChange={handleChange}
        size="small"
      />
    );
  } else {
    return <CircularProgress />;
  }
}

export default QueryAnatomic;
